import { c as _c } from "react/compiler-runtime";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import CommonIntersectionElement from "../CommonIntersectionElement";
import FollowersList from "./FollowersList";
export default function FollowersListWrapper(t0) {
  const $ = _c(11);
  const {
    followers,
    loading,
    onBottomIntersection,
    showFollowButtons: t1
  } = t0;
  const showFollowButtons = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== followers || $[1] !== showFollowButtons) {
    t2 = <FollowersList followers={followers} showFollowButtons={showFollowButtons} />;
    $[0] = followers;
    $[1] = showFollowButtons;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== loading) {
    t3 = loading && <div className="tw-mt-8 tw-w-full tw-text-center"><CircleLoader size={CircleLoaderSize.XXLARGE} /></div>;
    $[3] = loading;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onBottomIntersection) {
    t4 = <CommonIntersectionElement onIntersection={onBottomIntersection} />;
    $[5] = onBottomIntersection;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className="tw-h-full tw-overflow-hidden">{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}